<template>
  <v-dialog
    v-model="dialog"
    persistent
    :width="calcWidth"
    :fullscreen="fullscreen"
    scrollable
    @keydown.esc="dialog = false"
  >
    <node-editor
      ref="refnodeeditor"
      :meta="meta"
      :readonly="readonly"
      :node-id="nodeId"
      :parent-class-id="parentClassId"
      :can-sort="canSort"
      :size="tagsRating"
      @editor-close="$emit('close')"
      @apply="$emit('close')"
    />
  </v-dialog>
</template>
<script>
import NodeEditor from "./NodeEditor.vue";

export default {
  components: { NodeEditor },
  model: {
    prop: "open",
    event: "change"
  },
  props: {
    open: Boolean,
    meta: {
      type: Object,
      required: true
    },
    nodeId: {
      type: [String, Number],
      default: 0
    },
    readonly: {
      type: Boolean,
      required: true
    },
    canSort: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },

  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    },
    parentClassId() {
      const nodeData = this.$store.getters.getNodeFromAnyCache(this.nodeId);
      return nodeData?.cid || 0;
    },
    tagsRating() {
      const score = this.meta.tags.reduce((product, item) => {
        switch (item.typ) {
          case "TEXT":
            product += 500;
            break;
          case "IMAGE":
            product += 20;
            break;
          default:
            product += 4;
            break;
        }
        return product;
      }, 0);
      if (score < 25) {
        return "xs";
      } else if (score < 62) {
        return "sm";
      } else if (score < 240) {
        return "md";
      } else {
        return "lg";
      }
    },
    fullscreen() {
      return this.tagsRating == "lg";
    },
    calcWidth() {
      if (this.tagsRating == "xs") {
        return "1000px";
      } else if (this.rating == "sm") {
        return "90vw";
      } else {
        return "90vw";
      }
    }
  },
  watch: {
    open(v) {
      if (v && this.$refs.refnodeeditor) {
        this.$refs.refnodeeditor.reload();
      }
    }
  }
};
</script>
